<svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M0.834815 7.76553C0.684838 7.61551 0.600586 7.41207 0.600586 7.19994C0.600586 6.9878 0.684838 6.78436 0.834815 6.63434L3.46922 3.99994L0.834815 1.36554C0.689089 1.21465 0.608453 1.01257 0.610276 0.802814C0.612098 0.593057 0.696234 0.392407 0.84456 0.24408C0.992887 0.095754 1.19354 0.0116186 1.40329 0.00979587C1.61305 0.00797313 1.81513 0.088609 1.96601 0.234335L5.16601 3.43434C5.31599 3.58436 5.40024 3.7878 5.40024 3.99994C5.40024 4.21207 5.31599 4.41551 5.16601 4.56554L1.96601 7.76553C1.81599 7.91551 1.61255 7.99976 1.40042 7.99976C1.18828 7.99976 0.984837 7.91551 0.834815 7.76553Z"
		fill="#8F00FF"
	/>
</svg>
